import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  Snackbar
} from '@mui/material';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';

const PriceSettings = () => {
  const [price, setPrice] = useState('');
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    loadCurrentPrice();
  }, []);

  const loadCurrentPrice = async () => {
    try {
      const settingsRef = doc(db, 'settings', 'premium');
      const settingsDoc = await getDoc(settingsRef);
      
      if (settingsDoc.exists()) {
        setPrice(settingsDoc.data().packagePrice.toString());
      } else {
        // Varsayılan fiyat ayarı
        await setDoc(settingsRef, { packagePrice: 50 });
        setPrice('50');
      }
    } catch (error) {
      console.error('Fiyat yüklenirken hata:', error);
      showSnackbar('Fiyat yüklenirken hata oluştu', 'error');
    } finally {
      setLoading(false);
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handlePriceUpdate = async () => {
    try {
      const settingsRef = doc(db, 'settings', 'premium');
      await setDoc(settingsRef, { 
        packagePrice: Number(price),
        updatedAt: new Date()
      });
      showSnackbar('Paket fiyatı başarıyla güncellendi');
    } catch (error) {
      console.error('Fiyat güncellenirken hata:', error);
      showSnackbar('Fiyat güncellenirken hata oluştu', 'error');
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Premium Paket Fiyat Ayarları
      </Typography>
      
      <Box sx={{ mt: 2 }}>
        <TextField
          label="Paket Fiyatı (TL)"
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          fullWidth
          disabled={loading}
          InputProps={{
            endAdornment: <Typography>TL</Typography>
          }}
        />
        
        <Button
          variant="contained"
          onClick={handlePriceUpdate}
          disabled={loading}
          sx={{ mt: 2 }}
        >
          Fiyatı Güncelle
        </Button>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Paper>
  );
};

export default PriceSettings; 